import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "./HartuDateTimeBanner.css";
import groupDatesByDay from '../../../utils/dates/groupDatesByDay'
import convertDateToString from '../../../utils/dates/convertDateToString'
import convertTimeToString from '../../../utils/dates/convertTimeToString'
import { CalendarIcon, Time } from '../../../assets/svg/hartu'
import "select2";

export default function HartuDateTimeBanner({
  dates,
  lang
}) {
  const datesArray = groupDatesByDay(dates);
  const [dayToShowTime, setDayToShowTime] = useState(Object.keys(datesArray)[0]);

  return (
    <div className="hartuBookingForm__day-time-card--content row">
      <div class="col-8 pr-2 row">
        <CalendarIcon />
        <span>
          {Object.keys(datesArray).map(date => (
            <div className={`hour--container ${date === dayToShowTime ? 'selected' : ''}`} onClick={() => setDayToShowTime(date)}>
              {convertDateToString({ dates: [date], lang })}
            </div>
          ))}
        </span>
      </div>
      <div class="col-4 pl-2 row">
        <Time />
        <span>
          {datesArray[dayToShowTime]?.map((hours, i) => (
            <p key={i}>
              {hours}
            </p>
          ))}
        </span>
      </div>
    </div>
  );
}
